module.exports = __webpack_public_path__ + "assets/rubicon-project.44e4ed73.svg";